import React from 'react';
import {
	Box,
	Card,
	FormControl,
	FormControlLabel,
	Radio,
	RadioGroup,
	TextField,
	Typography,
} from '@mui/material';
import { useFormContext, Controller } from 'react-hook-form';
import { ParkingLocation } from 'containers/pages/CANpark/types/parkingLocation';

export const TowPolicySection: React.FC<{ loading: boolean }> = ({
	loading,
}) => {
	const { control, register, watch } = useFormContext<ParkingLocation>();
	const towPolicyType = watch('towPolicyType');

	return (
		<Card sx={{ padding: 1 }}>
			<Typography variant="body2" fontWeight={300}>
				Tow Policy
			</Typography>

			<FormControl fullWidth>
				<Controller
					control={control}
					name="towPolicyType"
					render={({ field }) => (
						<RadioGroup
							row
							{...field}
							sx={{ flexWrap: 'wrap', gap: 1 }}
						>
							<FormControlLabel
								value="never"
								control={<Radio />}
								label={
									<Typography variant="caption">
										Never
									</Typography>
								}
							/>
							<FormControlLabel
								value="afterXViolations"
								control={<Radio />}
								label={
									<Typography variant="caption">
										After X Violations
									</Typography>
								}
							/>
						</RadioGroup>
					)}
				/>
			</FormControl>

			{towPolicyType === 'afterXViolations' && (
				<Box display="flex" alignItems="center" gap={1} mt={1}>
					<Typography variant="body2" fontWeight={300}>
						Authorize tow after
					</Typography>
					<Controller
						control={control}
						name="towAfterViolations"
						rules={{
							required: 'This field is required',
							validate: (value) =>
								(!isNaN(value ?? 0) &&
									Number(value ?? 0) >= 0) ||
								'Must be zero or a positive number',
						}}
						render={({ field, fieldState }) => (
							<TextField
								{...field}
								value={field.value ?? ''}
								onChange={(e) => {
									const numeric = parseInt(
										e.target.value,
										10,
									);
									field.onChange(
										isNaN(numeric) ? '' : numeric,
									);
								}}
								type="number"
								variant="outlined"
								size="small"
								inputProps={{ min: 0 }}
								disabled={loading}
								sx={{ width: 100 }}
								error={!!fieldState.error}
								helperText={fieldState.error?.message}
							/>
						)}
					/>
					<Typography variant="body2" fontWeight={300}>
						violation(s)
					</Typography>
				</Box>
			)}
		</Card>
	);
};
